module.exports = "https://www.gc-qa.gnp.com.mx/f8978a8509881b3367124638187231f1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/carrusel-01.gif
// module id = 8070
// module chunks = 0